export const Spinner = () => {
  return (
    <div className="flex items-center justify-center h-full w-full py-10">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary" />
    </div>
  );
};
